/**
 * Story 9.13 (AC7 / LI-5) — the marketplace-side single source of truth for the
 * current Terms & Conditions version.
 *
 * This MUST mirror tph-api's `src/config/onboarding.js` `TOS_VERSION_CURRENT`
 * (cross-repo agreement): if the version ever bumps, both repos change their one
 * constant. There must be NO inline `'v2_2026'` literal anywhere else in this
 * repo — Screen 3 (the accept-tos UI) and the accept-tos server proxy re-stamp
 * both reference this constant.
 *
 * Authored as CommonJS so the SAME literal is consumable by both the webpack
 * client bundle (`import { TOS_VERSION_CURRENT }`) and the plain-Node dev API
 * server (`require`), without duplicating the value across the server/client
 * boundary.
 */
const TOS_VERSION_CURRENT = 'v2_2026';

module.exports = { TOS_VERSION_CURRENT };
